import { Link } from 'react-router-dom'
import { connectionProblemMessage, isConnectionValidationError, isUnusableConnection } from '@/lib/connectionErrors'

interface ConnectionProblemAlertProps {
  readonly projectId: string
  readonly error: unknown
  readonly connectionName?: string
  readonly connectorId?: string
  readonly testIdSuffix?: string
}

export function ConnectionProblemAlert({ projectId, error, connectionName, connectorId, testIdSuffix }: ConnectionProblemAlertProps) {
  const message = connectionProblemMessage(error, connectionName) ?? 'Could not load data from Azure DevOps.'
  const suffix = testIdSuffix ? `-${testIdSuffix}` : ''
  const connectorsPath = `/projects/${projectId}/connectors`
  const to = connectorId ? `${connectorsPath}?reconnect=${encodeURIComponent(connectorId)}` : connectorsPath
  const linkText = connectorId ? 'Reconnect' : 'Open connectors'

  return (
    <div role="alert" className="space-y-1 text-xs text-destructive" data-testid={`connection-problem-alert${suffix}`}>
      <p>{message}</p>
      {(isUnusableConnection(error) || isConnectionValidationError(error)) && (
        <Link
          to={to}
          className="font-medium underline"
          aria-label={connectorId && connectionName ? `Reconnect ${connectionName}` : undefined}
          data-testid={`connection-problem-reconnect${suffix}`}
        >
          {linkText}
        </Link>
      )}
    </div>
  )
}
